<template>
  <NTable
    class="dbox1"
    v-if="travels && travels.length > 0"
    :id="'cmp-booking-booking-booking_sidewindow-travel_list-' + type"
    :headers="travelHeaders"
    :items="travels"
    :config="tableConfig"
  >
    <template v-slot:item="{ item, tdcon }">
      <tr @click="(e) => onRowClick(item)" style="cursor: pointer">
        <td v-bind="tdcon('artist')">
          <span class="txtov td-inner" v-html="item['travellers']"></span>
        </td>
        <td v-bind="tdcon('itinerary')">
          <div class="itinerary-block">
            <span class="destination-block">
              <span class="line"></span>
            </span>
            <div class="keyvalue-container">
              <div class="keyvalue-item">
                <div class="key"> {{$t('from')}} </div>
                <div class="txtov value" v-html="item['origin']"></div>
              </div>
              <div class="keyvalue-item">
                <div class="key"> {{$t('to')}} </div>
                <div class="txtov value" v-html="item['destination']"></div>
              </div>
            </div>
          </div>
        </td>

        <td v-bind="tdcon('travel')">
          <span class="txtov" :title="item['travel_no']">
            {{ item["travel_no"] }}
          </span>
        </td>
        <td v-bind="tdcon('filekey')">
          <span class="txtov" v-html="item['booking_codes']"></span>
        </td>

        <td v-bind="tdcon('costs')" @click.stop>
          <span class="ut-jend">
            <span>
              {{ $dft.curr(item["costs"]) }}
              {{ $store.getters.account.client.default_currency }}
            </span>
          </span>
        </td>

        <td v-bind="tdcon('confirmed')">
          <div class="dt-checkbox v2 s1" :title="$t('confirm_travel')">
            <input
              type="checkbox"
              name="checkbox"
              id="checkbox"
              :checked="item['confirmed_flag'] == 1 ? true : false"
              @click.stop="(e) => onCheckboxChange(e, 'confirmed_flag', item)"
            />
            <div class="checkmark"></div>
          </div>
        </td>
        <td v-bind="tdcon('icon')">
          <img
            v-if="isTravelBeforeOnly(item)"
            @click.stop="(e) => onDownClicked(item)"
            src="static/icons/arrows/arrow-down.svg"
            class="dt-icon v5 s1 ut-center"
            :alt="$t('move_to_travel_after')"
            :title="$t('move_to_travel_after')"
          />
          <img
            v-if="isTravelBeforeOut(item)"
            src="static/icons/arrows/arrow-left.svg"
            class="dt-icon v5 s1 ut-center nohover"
            :alt="$t('travel_out')"
            :title="$t('travel_out')"
          />
          <img
            v-if="isTravelAfterOnly(item)"
            @click.stop="(e) => onUpClicked(item)"
            src="static/icons/arrows/arrow-up.svg"
            class="dt-icon v5 s1 ut-center"
            :alt="$t('move_to_travel_before')"
            :title="$t('move_to_travel_before')"
          />
          <img
            v-if="isTravelAfterOut(item)"
            src="static/icons/arrows/arrow-right.svg"
            class="dt-icon v5 s1 ut-center nohover"
            :alt="$t('travel_out')"
            :title="$t('travel_out')"
          />
        </td>
        <td @click.stop v-bind="tdcon('close')">
          <img
            @click.stop="(e) => onCloseClicked(item)"
            src="static/icons/delete.svg"
            class="dt-icon v5 s1 ut-center"
            :alt="$t('delete_travel')"
            :title="$t('delete_travel')"
          />
        </td>
      </tr>
    </template>
  </NTable>
  <div v-else>
    <div
      v-if="preview_load_travel && preview_load_travel.length > 0"
      class="ut-flex ut-fc"
      style="padding-left: 0px; padding-top: 8px; align-items: flex-start"
    >
      <SearchList
        :id="'relationTypes'"
        :items="
          preview_load_travel.map((travelFrom) => ({
            ...travelFrom,
            travelTitle: `${travelFrom.contact_name}, ${travelFrom.cd_start_date}, ${travelFrom.cd_city}`,
          }))
        "
        :itemsMultipleMargin="false"
        :keyProperty="'contact_id'"
        :label="'travelTitle'"
        :isSearchable="false"
        :selected="selectedContactTravels"
        @selected="onContactTravelsSelected"
      />
      <button
        style="margin-top: 12px; margin-left: 14px"
        class="dt-button v5 s8"
        @click="onLoadTravelClick"
      >
        {{$t('load_travel')}}
      </button>
    </div>
  </div>
</template>

<script>
// if before {
//  calendar_date_id is the Main CDate ID
//  travel calendar_date_id = cdate calendar_date_id
//  travel calendar_date_id_out = old cdate calendar_date_id
// }  if after {
//  calendar_date_id_out is the Main CDate ID
//  travel calendar_date_id_out = cdate calendar_date_id
//  travel calendar_date_id = old cdate calendar_date_id
// }

import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import SearchList from "@dtplugins/search-list/search-list";
import {
  isTravelAfterOnly,
  isTravelAfterOut,
  isTravelBeforeOnly,
  isTravelBeforeOut,
} from "../../models/travel.model";

export default {
  components: {
    NTable,
    SearchList,
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        headerHeight: 28,
        rowHeight: 122,
        fullHeight: true,
        footer: false,
      }),
      selectedContactTravels: new Set(),
    };
  },
  props: {
    type: {
      default: "before",
      type: String,
    },
    booking: {
      required: true,
      type: Object,
    },
    travels: {
      required: true,
      type: Array,
    },
    preview_load_travel: {
      required: true,
      type: Array,
    },
    // selectedContactTravels: {
    //   required: true,
    //   type: Set,
    // },
    travelHeaders: {
      required: true,
    },
  },
  methods: {
    isTravelBeforeOnly: isTravelBeforeOnly,
    isTravelBeforeOut: isTravelBeforeOut,
    isTravelAfterOnly: isTravelAfterOnly,
    isTravelAfterOut: isTravelAfterOut,
    onRowClick: function (item) {
      this.$emit("selected", item);
    },
    onTextInputBlur: function (event, name, item) {
      this.$emit("onTravelChange", { value: event.target.value, name, item });
    },
    onCheckboxChange: function (event, name, item) {
      const checked = event.target.checked;

      const calendarDateArtistId = item.calendar_date_artist_id;

      const value = checked === true ? "1" : "0";

      this.$emit("onTravelChange", { name, value, item });
    },
    onCloseClicked: function (travel) {
      this.$emit("delete", travel);
    },
    onUpClicked: function (item) {
      this.$emit("onTravelChange", {
        value: "0",
        name: "after_gig_flag",
        item,
      });
    },
    onDownClicked: function (item) {
      this.$emit("onTravelChange", {
        value: "1",
        name: "after_gig_flag",
        item,
      });
    },
    onContactTravelsSelected(contactTravels) {
      this.selectedContactTravels = contactTravels;
    },
    onLoadTravelClick() {
      this.$emit("load_travel", {
        type: this.type,
        selectedContactTravels: Array.from(this.selectedContactTravels).map(
          (e) => this.preview_load_travel.find((f) => f.contact_id == e)
        ),
      });
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-booking-booking-booking_sidewindow-travel_list-before,
.cmp-booking-booking-booking_sidewindow-travel_list-after {
  // --ntable-height: 196px !important;
  --ntable-height: auto !important;
  td {
    justify-content: flex-start !important;
    &.costs,
    &.filekey,
    &.close,
    &.icon,
    &.confirmed {
      .ut-center,
      .dt-checkbox {
        margin: 0 auto !important;
      }
    }
    &.costs,
    &.filekey,
    &.close,
    &.icon {
      padding-top: 3px;
    }
    &.confirmed {
      padding-top: 9px;
    }
  }

  .itinerary-block {
    display: flex;
    .destination-block {
      display: block;
      flex: 0 1 12px;
      max-width: 12px;
      position: relative;

      &:before,
      &:after {
        content: "";
        position: absolute;
        left: 0;
        width: 12px;
        height: 12px;
        border-radius: 50%;
      }
      &:before {
        top: 8px;
        border: 2px solid #000;
      }
      &:after {
        top: 35px;
        background-color: #000;
      }

      .line {
        display: block;
        width: 1px;
        height: 20px;
        background-color: #000;
        margin: 19px auto 0;
      }
    }
    .keyvalue-container {
      flex: 1;
      padding-left: 12px;
    }
  }

  // height: 100% !important;
  // &.scroller {
  //   thead {
  //     tr {
  //       padding-right: 15px;
  //     }
  //   }
  // }

  // td,
  // th {
  //   flex: 1;
  //   padding: 0px;
  //   box-sizing: border-box;
  // }

  // th {
  //   .header-name {
  //     padding-left: 10px;
  //   }
  // }

  // th:nth-child(8),
  // td:nth-child(8),
  // th:nth-child(9),
  // td:nth-child(9),
  // th:nth-child(10),
  // td:nth-child(10) {
  //   width: 30px !important;
  //   max-width: 30px !important;
  // }

  // td:nth-child(1),
  // td:nth-child(3),
  // td:nth-child(4),
  // td:nth-child(5),
  // td:nth-child(6),
  // td:nth-child(7) {
  //   display: flex;
  //   flex-direction: column;
  //   .td-inner {
  //     flex: 1;
  //     margin-top: 5px;
  //   }
  // }
  // th:nth-child(2),
  // td:nth-child(2) {
  //   flex: 2;
  // }

  // th:nth-child(2),
  // td:nth-child(2) {
  //   flex: 0.5;
  // }

  // td:nth-child(8),
  // td:nth-child(9),
  // td:nth-child(10) {
  //   margin-top: 5px;
  //   display: block;
  // }
  // td:nth-child(9),
  // td:nth-child(10) {
  //   margin-top: 0px;
  // }

  // td.itinerary {
  //   margin-top: 5px;
  // }

  // td.confimed {
  //   .td-inner {
  //     padding-top: 3px;
  //   }
  // }

  .keyvalue-container {
    display: flex;
    flex-direction: column;
    .keyvalue-item {
      display: flex;

      .value {
        margin: 0px 10px;
      }

      .key {
        margin: 0px;
        min-width: 30px;
        text-align: right;
      }
      .value {
        flex: 1;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.cmp-booking-booking-booking_sidewindow-travel_before,
.cmp-booking-booking-booking_sidewindow-travel_after {
  .dt-table2 {
    --body-height: auto !important;
    width: 400px;
    .dt-table2--body {
      background: transparent !important;
      border: none !important;
      .dt-table2--column {
        border-bottom: none !important;
      }
    }
  }
}
</style>

